import { useQuery } from '@tanstack/react-query';
import type { SaveEvent } from 'containers/LeaveDialogue/LeaveDialog';
import { LoaderAndText } from 'containers/LoaderAndText/LoaderAndText';
import type React from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { makeFormikOnSubmit } from 'utils/formik/makeFormikOnSubmit';
import { useApi } from 'utils/request/useApi';
import {
  IpfCertificateForm,
  type IpfCertificateFormFields,
} from './CertificateRequestForm';
import { generateNimpeeCertificate } from './model/command/generateNimpeeCertificate';
import { useIpfCertificate } from './model/useIpfCertificate';

export const IpfCertificate: React.FC = () => {
  const model = useIpfCertificate();
  const [transitionUrl, setTransitionUrl] = useState<SaveEvent>();

  const api = useApi();
  const { data } = useQuery(
    api.query({
      method: 'GET',
      url: '/os/hostname',
    }),
  );

  const handleSubmit = makeFormikOnSubmit(
    async (values: IpfCertificateFormFields) => {
      await model.dispatch(generateNimpeeCertificate, {
        values,
        transitionUrl,
      });
    },
  );

  if (!data?.hostname) {
    return (
      <div className='box box-solid mb-0 flex flex-1 items-center'>
        <LoaderAndText />
      </div>
    );
  }

  return (
    <div className='m-4'>
      <Helmet title={'IP Fabric Certificate'} />
      <IpfCertificateForm
        onSubmit={handleSubmit}
        model={model}
        commonName={data.hostname}
        setTransitionUrl={setTransitionUrl}
      />
    </div>
  );
};
